module.exports = __webpack_public_path__ + "static/media/ProfileIcon.f992face.png";